import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as styles from "./Checkbox.module.css";
export const InputCheckbox = _ref => {
  let {
    name,
    validation,
    register,
    label,
    defaultChecked,
    disabled
  } = _ref;
  return _jsxs("div", {
    className: styles.container,
    children: [_jsx("input", {
      type: "checkbox",
      id: `checkbox${name}`,
      ...{
        defaultChecked,
        disabled
      },
      ...register(name, {
        ...validation
      })
    }), _jsx("label", {
      htmlFor: `checkbox${name}`,
      children: label
    })]
  });
};